/* eslint-disable */
import { Injectable } from '@angular/core';

@Injectable()
export class SessionStorageService {
  /**
   * Get all or some of data out of localstorage.
   * @public
   * @param {?}   arguments   - the groups or keys names.
   * @return      object      - the groups or keys values.
   */
  get() {
    var storage = {};
    if (arguments.length !== 0) { //get values of given arguments.
      for (var arg in arguments) {
        try {
          storage[arguments[arg]] = JSON.parse(sessionStorage.getItem(arguments[arg]));
        }
        catch (e) {
          storage[arguments[arg]] = sessionStorage.getItem(arguments[arg]);
        }
      }
    //if not receive any arguments returns all storage values.
    } else { 
      for (var i = sessionStorage.length - 1; i >= 0; i--) {
        try {
          storage[sessionStorage.key(i)] = JSON.parse(sessionStorage.getItem(sessionStorage.key(i)));
        }
        catch (e) {
          storage[sessionStorage.key(i)] = sessionStorage.getItem(sessionStorage.key(i));
        }
      }
    }
    return storage;
  }

  /**
   * Finds a key in local storage.
   * @public
   * @param {String}    key     - Name of the key.
   * @return {?}      data    - The key and its value.
   */
  getItem(key) {
    if (key) {
      try {
        return JSON.parse(sessionStorage.getItem(key));
      } catch (e) {
        return sessionStorage.getItem(key);
      }
    }
  }

  /**
   * Updates a value of a key by key and or group name.
   * @public
   * @param {String}  key     - Name of the key.
   * @param {?}   value   - The new data.
   * @param {String}  groupName - Name of the group.
   */
  updateItem(key, value, groupName) {
    var storage;
    if (groupName) {
      storage = this.get(groupName);
      storage[groupName][key] = value;
      sessionStorage.setItem(groupName, JSON.stringify(storage[groupName]));
    } else {
      storage = this.get(key);
      storage[key] = value;
      sessionStorage.setItem(key, JSON.stringify(storage[key]));
    }
  }

  /**
   * Creates new key and value
   * @public
   * @param {String}  key     - Name of the key.
   * @param {?}   value   - The new data.
   */
  setItem(key, value) {
    if (typeof value === 'object') {
      value = JSON.stringify(value);
    }
    sessionStorage.setItem(key, value);
  }

  /**
   * Deletes a key.
   * @public
   * @param {String}    key   - The key for an event.
   */
  removeItem(event) {
    sessionStorage.removeItem(key);
  }

  /**
   * Deletes everything in local storage.
   * @public
   */
  clear() {
    sessionStorage.clear();
  }
}